<template>
  <div class="wrapper">
    <div class="content">
      <Nav :isTop="true" />
      <div class="content-wrap">
        <div class="content-info">
          <Tree
            ref="tree"
            v-loading="loading"
            :tree="tree"
            @fetchList="fetchList"
          />
          <ListComp ref="listRef" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/views/layout/contentInfo/nav.vue'
import ListComp from './components/listComp.vue'
import Tree from './components/tree.vue'

export default {
  components: {
    Nav,
    ListComp,
    Tree
  },
  data () {
    return {
      loading: false,
      tree: []
    }
  },
  async created () {
    await this.getTreeList()

    if (this.$route.query.id) {
      const queryTree = this.tree.find(
        (item) => item.id === this.$route.query.id
      )

      let treeId = this.$route.query.treeId

      // 如果路由上没带二级类目树id则默认取对应id的一级类目下的第一个
      if (
        queryTree &&
        queryTree.childrenList &&
        queryTree.childrenList.length
      ) {
        const idTree = queryTree.childrenList[0].id
        this.fetchList(queryTree, treeId || idTree)
      } else {
        // 如果类目找不到下架了，则取第一个一级下的第一个二级
        this.getListByFirst()
      }
    } else {
      // 如果类目找不到下架了，则取第一个一级下的第一个二级
      this.getListByFirst()
    }
  },
  methods: {
    // 如果类目找不到下架了，则取第一个一级下的第一个二级
    getListByFirst () {
      if (
        this.tree &&
        this.tree[0] &&
        this.tree[0].childrenList &&
        this.tree[0].childrenList[0]
      ) {
        this.fetchList(this.tree[0], this.tree[0].childrenList[0].id)
      }
    },
    // 获取文章列表
    fetchList (parent, categoryId) {
      this.$nextTick(() => {
        // 通过tree触发加载文章列表-可以默认展开树
        this.$refs.tree.setActiveName(parent.id, categoryId)

        // 请求列表数据
        this.$refs.listRef.init(categoryId, (parent && parent.name) || '-')
      })
    },
    // 获取左侧类目
    async getTreeList () {
      if (this.tree.length) return

      this.loading = true
      await this.$http
        .get('/front/oms/openapi/shopping-content-information/category/tree')
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.tree = res.data || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  background: #fff;
  font-family: Alibaba PuHuiTi;

  .content {
    width: 1200px;
    min-height: calc(100vh - 120px);

    .content-wrap {
      padding-top: 40px;

      .content-info {
        width: 100%;
        display: flex;

        /* 样式2 start 如不需要整块删除可恢复flex */
        display: block;
        .tree-wrapper {
          display: inline-block;
          vertical-align: top;
          position: sticky;
          top: 53px;
        }

        .list-wrap {
          display: inline-block;
          width: calc(100% - 280px);
          vertical-align: top;
        }
        /* 样式2 end */
      }
    }
  }
}
</style>
